// removed by extract-text-webpack-plugin
module.exports = {"PostList":"_3O1g5Y6IBaX5pwYlx2PqE2","NoPostsText":"cJf7aNaeVCoQnEqopRSSG","PostListWrapper":"_1d5HTm3BILkutnCSma_SY2"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Posts/style.css
// module id = 2036
// module chunks = 0